<div class="card-body p-0">
<form [formGroup]="searchForm" autocomplete="off">
    <div class="row" *ngIf="searchForm">
        <div class="col-md-4 mt-3 ps-4">
            <div class="mb-3">
                <input type="text" class="form-control input-default search-textbox-height" placeholder="Search with name or email"
                    formControlName="search" autocomplete="off" />
            </div>
        </div>
        <div class="col-md-3 mt-3">
            <select class="form-select" formControlName="role_identifier" (change)="handleSearch('')">
                <option value="null" selected disabled>Please select</option>
                <option value="maintenance_manager">Maintenance Manager</option>
                <option value="property_manager">Property Manager</option>
                <option value="partner_admin">Partner Admin</option>
                <option value="telecaller">Telecaller</option>
                <option value="owner">Owner</option>
                <option value="tenant">Tenant</option>
            </select>
        </div>
        <div class="col-md-1 mt-3">
            <button class="btn btn-danger btn-sm  mt-0 float-end"  type="button" (click)="resetSearchForm()" [disabled]="!disableClear">Clear</button>
        </div>
    </div>
</form>
<div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper">
    <div class="tbl-caption d-none">
        <h4 class="heading mb-0">Users</h4>
        <div *ngIf="checkAddUser">
            <a class="btn btn-primary btn-sm me-1" href="javascript:void(0);" (click)="addUserToggle()">+ Add User</a>
        </div>
    </div>
    <table matSort (matSortChange)="sortData($event)" id="empoloyees-tbl" class="table mb-0">
        <thead>
            <tr>
                @if(checkbox){
                <th>
                    <div class="form-check custom-checkbox ms-0">
                        <input type="checkbox" class="form-check-input checkAllInput" id="checkAll2"
                            (click)="checkUncheckAll()">
                        <label class="form-check-label" for="checkAll2"></label>
                    </div>
                </th>
                }
                <th mat-sort-header="firstName">First name</th>
                <th mat-sort-header="lastName">Last Name</th>
                <th mat-sort-header="email">Email Address</th>
                <th mat-sort-header="mobile">Contact Number</th>
                <th mat-sort-header="userType">User Type</th>
                <th mat-sort-header="status">Joined</th>
                <th class="text-center">Action</th>
            </tr>
        </thead>
        <tbody>
            @for(item of allData.data; track item.uid){
            <tr>
                @if(checkbox){
                <td>
                    <div class="form-check custom-checkbox">
                        <input type="checkbox" class="form-check-input" id="customCheckBox0100" [checked]="boxActive">
                        <label class="form-check-label" for="customCheckBox0100"></label>
                    </div>
                </td>
                }
                <td><span>{{ item.first_name }}</span></td>
                <td>
                    <span>{{ item.last_name }}</span>
                </td>
                <td>{{ item.email }}</td>
                <td>
                    <span>{{ item.phone }}</span>
                </td>
                <td>
                    <span>{{ item.Role.name }}</span>
                </td>
                <td>
                    <span>{{ item.created_at | date:'dd-MM-yyyy' }}</span>
                </td>
                <!-- <td>
                    @if(item.status == 'Pending'){
                    <span class="badge badge-danger light border-0">{{item.status}}</span>
                    } @else {
                    <span class="badge badge-success light border-0">{{item.status}}</span>
                    }
                </td> -->
                <td class="text-center">
                    <button *ngIf="checkEditUser" type="button" class="btn btn-primary shadow btn-xs sharp me-1 mb-1" (click)="selectUser(item.uid)" [disabled]="loadingService.isLoading()"><i class="fa fa-pencil"></i></button>
                    <button *ngIf="checkDeleteUser" type="button" (click)="deleteUser(item.uid)" class="btn btn-danger shadow btn-xs sharp mb-1" [disabled]="loadingService.isLoading()"><i class="fa fa-trash"></i></button>
                </td>
            </tr>
            }
        </tbody>
    </table>
    <div class="dataTables_info" id="example5_info" role="status" aria-live="polite">Showing {{page}} to
        {{totalRows}} of {{ allData.total }} entries</div>
    <div class="dataTables_paginate paging_simple_numbers pt-2">
        <app-pagination [totalPage]="totalPage" [page]="page" (newPage)="pageChange($event)"></app-pagination>
    </div>
</div>
</div>
<div #addEditUser class="offcanvas offcanvas-end customeoff {{ offcanvasExample?'show':''}}" tabindex="-1" id="offcanvasExample" data-bs-backdrop="static">
    <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">{{ selectedUserId ? "Edit" : "Add" }} User</h5>
      <button type="button" class="btn-close" (click)="close()">
          <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="container-fluid">
        <form [formGroup]="userForm" (ngSubmit)="onSubmit()" >
          <div class="display">
              <label>Profile Picture</label>
              <div class="dz-default dlab-message upload-img mb-3">
                  <div class="dropzone">
                      <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M27.1666 26.6667L20.4999 20L13.8333 26.6667" stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M20.5 20V35" stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M34.4833 30.6501C36.1088 29.7638 37.393 28.3615 38.1331 26.6644C38.8731 24.9673 39.027 23.0721 38.5703 21.2779C38.1136 19.4836 37.0724 17.8926 35.6111 16.7558C34.1497 15.619 32.3514 15.0013 30.4999 15.0001H28.3999C27.8955 13.0488 26.9552 11.2373 25.6498 9.70171C24.3445 8.16614 22.708 6.94647 20.8634 6.1344C19.0189 5.32233 17.0142 4.93899 15.0001 5.01319C12.9861 5.0874 11.015 5.61722 9.23523 6.56283C7.45541 7.50844 5.91312 8.84523 4.7243 10.4727C3.53549 12.1002 2.73108 13.9759 2.37157 15.959C2.01205 17.9421 2.10678 19.9809 2.64862 21.9222C3.19047 23.8634 4.16534 25.6565 5.49994 27.1667" stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M27.1666 26.6667L20.4999 20L13.8333 26.6667" stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div class="fallback">
                          <input name="file" type="file" >

                      </div>
                    </div>
              </div>
          </div>

              <div class="row">
                  <div class="col-xl-6 mb-3">
                      <label for="exampleFormControlInput1-1" class="form-label">First Name<span class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="user" formControlName="first_name">
                      <div *ngIf="userForm?.get('first_name')?.invalid && userForm?.get('first_name')?.touched" class="required">
                        First Name is required
                    </div>
                  </div>
                  <div class="col-xl-6 mb-3">
                      <label for="exampleFormControlInput1-2" class="form-label">Last Name<span class="text-danger">*</span></label>
                      <input type="text" class="form-control" id="exampleFormControlInput1-2" placeholder="user1" formControlName="last_name">
                      <div *ngIf="userForm?.get('last_name')?.invalid && userForm?.get('last_name')?.touched" class="required">
                        Last Name is required
                    </div>
                  </div>
                  <div class="col-xl-6 mb-3">
                      <label for="exampleFormControlInput1-3" class="form-label">User Email<span class="text-danger">*</span></label>
                      <input type="email" class="form-control" id="exampleFormControlInput1-3" placeholder="aa@aa.com" formControlName="email">
                      <div *ngIf="userForm?.get('email')?.invalid && userForm?.get('email')?.touched" class="required">
                        Provide valid email
                    </div>
                  </div>
                  <div class="col-xl-6 mb-3">
                      <label for="exampleFormControlInput1-4" class="form-label">Mobile Number<span class="text-danger">*</span></label>
                      <input type="number" class="form-control" id="exampleFormControlInput1-4" placeholder="9876543210" formControlName="phone">
                      <div *ngIf="userForm?.get('phone')?.errors?.['required'] && userForm?.get('phone')?.touched" class="required">
                        Mobile number is required
                    </div>
                    <div *ngIf="userForm?.get('phone')?.errors?.['pattern'] && userForm?.get('phone')?.touched" class="required">
                        Enter a valid 10-digit mobile number
                    </div>
                  </div>
                  <div class="col-xl-6 mb-3">
                      <label class="form-label">User Type<span class="text-danger">*</span></label>
                      <select class="form-select" formControlName="role_identifier">
                          <option value="null" selected disabled>Please select</option>
                          <option value="maintenance_manager">Maintenance Manager</option>
                          <option value="property_manager">Property Manager</option>
                          <option value="partner_admin">Partner Admin</option>
                          <option value="telecaller">Telecaller</option>
                      </select>
                      <div *ngIf="userForm?.get('role_identifier')?.invalid && userForm?.get('role_identifier')?.touched" class="required">
                        Select user type
                    </div>
                  </div>
              </div>
              <div>
                  <button class="btn btn-primary ms-1 me-3" type="submit" [disabled]="userForm.invalid || loadingService.isLoading()" *ngIf="checkEditUser">Save</button>
                  <button class="btn btn-danger lightme-1" type="button" (click)="close()">Close</button>
              </div>
          </form>
        </div>
    </div>
  </div>
  @if(offcanvasExample){
    <div class="offcanvas-backdrop fade show" (click)="toggleExample()"></div>
}
